import {
    NewPlanStages,
    policyDetailsInitState,
} from 'components/newPlan/constants';
import { createContext } from 'react';
import { Partners } from 'utils/constants';
import { IUserAccessItem } from 'utils/helpers/userAccess';

export interface IFormConfig {
    uiConfig: any;
    should_capture_details: boolean;
    details_update_required: boolean;
    captured_data?: Record<string, any>;
}

export type FormConfigsMap = {
    [form_type: string]: IFormConfig;
};

interface IMposContext {
    cookie: string;
    partnerId: Partners | string;
    permissions: {
        group: string;
        partner_id: string;
        partner_logo: string;
        role: string;
        permission_list: string[];
        purchase_journey: string;
        lob?: string;
    };
    userDetails: {
        user_id: string;
        address: string;
        email: string;
        name: string;
        partner_id: string;
        phone: string;
        pincode: string;
    };
    metaData: {
        promoter_id_visibility: boolean;
    };
    activeStage: string;
    planDetails: any;
    legalDetailsUploadedStatus: boolean | null;
    loggedUserRole: string;
    gstDetailsValid: boolean;
    gstDetailsSubmitAction: boolean;
    formConfigsMap: FormConfigsMap;
    userAccessList: IUserAccessItem[];
    setPlanDetails: any;
    setUserAccessList: any;
    setActiveStage: any;
    permissionsMap: { [permission: string]: boolean };
    dealerType: string;
    showHamburger: boolean;
    setPermissions: any;
    setUserDetails: any;
    setPartnerId: any;
    setShowHamburger: any;
    setSnackbar: any;
    setLoggedUserRole: any;
    setGstDetailsValid: any;
    setGstDetailsSubmitAction: any;
    setLegalDetailsUploadedStatus: any;
    setMetaData: any;
    setPermissionsMap: any;
    setFormConfigsMap: any;
}

export const MPosContext = createContext<IMposContext>({
    cookie: '',
    partnerId: '',
    permissions: {
        group: '',
        partner_id: '',
        partner_logo: '',
        permission_list: [],
        role: '',
        purchase_journey: 'v0',
    },
    userDetails: {
        user_id: '',
        address: '',
        email: '',
        name: '',
        partner_id: '',
        phone: '',
        pincode: '',
    },
    metaData: {
        promoter_id_visibility: false,
    },
    dealerType: '',
    showHamburger: true,
    permissionsMap: {},
    activeStage: NewPlanStages.MODEL,
    planDetails: policyDetailsInitState,
    legalDetailsUploadedStatus: null,
    loggedUserRole: '',
    gstDetailsValid: true,
    gstDetailsSubmitAction: true,
    formConfigsMap: {},
    userAccessList: [],
    setPlanDetails: () => {},
    setUserAccessList: () => {},
    setActiveStage: () => {},
    setPermissions: () => {},
    setUserDetails: () => {},
    setPartnerId: () => {},
    setShowHamburger: () => {},
    setSnackbar: () => {},
    setLoggedUserRole: () => {},
    setLegalDetailsUploadedStatus: () => {},
    setGstDetailsValid: () => {},
    setMetaData: () => {},
    setPermissionsMap: () => {},
    setGstDetailsSubmitAction: () => {},
    setFormConfigsMap: () => {},
});
